import { render, staticRenderFns } from "./selectAddress.vue?vue&type=template&id=af2d00a6&scoped=true&"
import script from "./selectAddress.vue?vue&type=script&lang=js&"
export * from "./selectAddress.vue?vue&type=script&lang=js&"
import style0 from "./selectAddress.vue?vue&type=style&index=0&id=af2d00a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2d00a6",
  null
  
)

export default component.exports